<div class="container" style="padding-top: 2%;">
  <div class="row" style="height: 8vh;">
    <div class="col-12" style="display: flex; justify-content: center;">
      <h1>¡Bienvenido a TROBBIT!</h1>
    </div>
  </div>
  <div class="row" style="height: 72vh;">
    <div class="col-12" style="height: 100%;">
      <div class="container mt-1" style="height: 100%;">
        <form>
          <mat-horizontal-stepper [linear]="true" [labelPosition]="'bottom'" #stepper>
            <mat-step [completed]="true">
              <ng-template matStepLabel>Saludo</ng-template>
              <div class="container step-content">
                <div class="row mb-2 mt-2">
                  <div class="col-12">
                    <h5>Añade una frase de bienvenida para los usuarios que van a hablar con tu bot y una frase en caso de que el bot no logre reconocer lo que el usuario dijo</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label for="welcomeResponse">Saludo</label>
                      <input type="text" class="form-control" id="welcomeResponse" name="welcomeResponse" [(ngModel)]="model.welcomeResponse" required
                        #welcomeResponse="ngModel" [ngModelOptions]="{updateOn: 'change'}">
                      <small class="form-text text-danger"
                        *ngIf="!welcomeResponse.valid && (welcomeResponse.dirty || welcomeResponse.touched)">{{'common.requiredField' | translate}}</small>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label for="fallbackResponse">Fallback</label>
                      <input type="text" class="form-control" id="fallbackResponse" name="fallbackResponse" [(ngModel)]="model.fallbackResponse" required
                        #fallbackResponse="ngModel" [ngModelOptions]="{updateOn: 'change'}">
                      <small class="form-text text-danger"
                        *ngIf="!fallbackResponse.valid && (fallbackResponse.dirty || fallbackResponse.touched)">{{'common.requiredField' | translate}}</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="step-actions">
                <button matStepperNext class="btn btn-info">Siguiente</button>
              </div>
            </mat-step>
            <mat-step [completed]="true">
              <ng-template matStepLabel>Apariencia</ng-template>
              <div class="container step-content">
                  <div class="row mb-2 mt-2">
                    <div class="col-12">
                      <h5>Configura la apariencia de tu bot</h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label for="botName">Nombre</label>
                        <input type="text" class="form-control" id="botName" name="botName" [(ngModel)]="model.settings.botName" required
                          #botName="ngModel" [ngModelOptions]="{updateOn: 'change'}">
                        <small class="form-text text-danger"
                          *ngIf="!botName.valid && (botName.dirty || botName.touched)">{{'common.requiredField' | translate}}</small>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label for="botDescription">Descripcion</label>
                        <input type="text" class="form-control" id="botDescription" name="botDescription" [(ngModel)]="model.settings.botDescription" required
                          #botDescription="ngModel" [ngModelOptions]="{updateOn: 'change'}">
                        <small class="form-text text-danger"
                          *ngIf="!botDescription.valid && (botDescription.dirty || botDescription.touched)">{{'common.requiredField' | translate}}</small>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <div class="input-group">
                          <input class="mr-2 color-input" name="windowColor" [(colorPicker)]="model.settings.windowColor" [style.background]="model.settings.windowColor"/>
                          <label for="windowColor"> {{'admin.settings.bot.style.titleBackground' | translate}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <div class="input-group">
                          <input class="mr-2 color-input" name="windowTextColor" [(colorPicker)]="model.settings.windowTextColor" [style.background]="model.settings.windowTextColor"/>
                          <label for="windowTextColor"> {{'admin.settings.bot.style.titleText' | translate}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <div class="input-group">
                          <input class="mr-2 color-input" name="userMessageColor" [(colorPicker)]="model.settings.userMessageColor" [style.background]="model.settings.userMessageColor"/>
                          <label for="userMessageColor"> {{'admin.settings.bot.style.userMessageBackground' | translate}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <div class="input-group">
                          <input class="mr-2 color-input" name="userMessageTextColor" [(colorPicker)]="model.settings.userMessageTextColor" [style.background]="model.settings.userMessageTextColor"/>
                          <label for="userMessageTextColor"> {{'admin.settings.bot.style.userMessageText' | translate}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <div class="input-group">
                          <input class="mr-2 color-input" name="botMessageColor" [(colorPicker)]="model.settings.botMessageColor" [style.background]="model.settings.botMessageColor"/>
                          <label for="botMessageColor"> {{'admin.settings.bot.style.botMessageBackground' | translate}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <div class="input-group">
                          <input class="mr-2 color-input" name="botMessageTextColor" [(colorPicker)]="model.settings.botMessageTextColor" [style.background]="model.settings.botMessageTextColor"/>
                          <label for="botMessageTextColor"> {{'admin.settings.bot.style.botMessageText' | translate}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <div class="input-group">
                          <input class="mr-2 color-input" name="quickRepliesColor" [(colorPicker)]="model.settings.quickRepliesColor" [style.background]="model.settings.quickRepliesColor"/>
                          <label for="quickRepliesColor"> {{'admin.settings.bot.style.quickRepliesBackground' | translate}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <div class="input-group">
                          <input class="mr-2 color-input" name="quickRepliesTextColor" [(colorPicker)]="model.settings.quickRepliesTextColor" [style.background]="model.settings.quickRepliesTextColor"/>
                          <label for="quickRepliesTextColor"> {{'admin.settings.bot.style.quickRepliesText' | translate}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              <div class="step-actions">
                <button matStepperPrevious class="btn btn-info mr-1">Anterior</button> 
                <button matStepperNext class="btn btn-info">Siguiente</button>
              </div>
            </mat-step>
            <mat-step [completed]="true">
              <ng-template matStepLabel>Conversaciones prestablecidas</ng-template>
              <div class="step-content container">
                <div class="row mb-2 mt-2">
                  <div class="col-12">
                    <h5>Añade paquetes de conversaciones prestablecidas</h5>
                  </div>
                </div>
                <div class="list-group">
                  <div class="list-group-item mb-1" *ngFor="let category of favoriteCategories">
                    <div class="row" style="display: flex; align-items: center;">
                      <div class="col-10">
                        {{category.name}}
                        <br>
                        <small>{{category.description}}</small>
                      </div>
                      <div class="col-2" style="display: flex; justify-content: flex-end;">
                        <button class="btn btn-info" type="button" (click)="addCategory(category.id)" *ngIf="!this.model.favoriteCategories.includes(category.id)"><i class="ti-plus"></i></button>
                        <button class="btn btn-danger" type="button" (click)="removeCategory(category.id)" *ngIf="this.model.favoriteCategories.includes(category.id)"><i class="ti-minus"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="step-actions">
                <button matStepperPrevious class="btn btn-info mr-1">Anterior</button> 
                <button matStepperNext class="btn btn-info">Siguiente</button>
              </div>
            </mat-step>
            <mat-step [completed]="true">
              <ng-template matStepLabel>Cargar intenciones</ng-template>
              <div class="step-content container">
                <div class="row mb-2 mt-2">
                  <div class="col-12">
                    <h5>Añade tus intenciones a través de un archivo Excel siguiendo la plantilla.</h5>
                  </div>
                </div>
                <a class="btn btn-info waves-effect waves-light mr-2" href="assets/files/template.xlsx" download="Plantilla.xlsx">
                  <span class="btn-label"><i class="mdi mdi-download"></i></span> {{'admin.intents.list.loadIntentsModal.downloadTemplate' | translate}}
                </a>
                <hr>
                <input style="display: none" type="file" accept=".xlsx, .xls, .csv" (change)="onFileChanged($event)" #fileInput>
                <button class="btn btn-info waves-effect waves-light mb-3" type="button" (click)="fileInput.click()">
                  <span class="btn-label"><i class="mdi mdi-file-excel"></i></span>{{'admin.intents.list.loadIntentsModal.uploadXLSX' | translate}}
                </button>
                <div class="alert alert-danger" role="alert" *ngIf="!isFileValid">
                  <strong>
                    {{'admin.intents.list.loadIntentsModal.invalidFile' | translate}}
                  </strong>
                </div>
                <div class="alert alert-success" role="alert" *ngIf="model.xlsFile && isFileValid">
                  <strong>
                    Archivo subido
                  </strong>
                </div>
              </div>
              <div class="step-actions">
                <button matStepperPrevious class="btn btn-info mr-1">Anterior</button> 
                <button matStepperNext class="btn btn-info">Siguiente</button>
              </div>
            </mat-step>
            <mat-step>
              <ng-template matStepLabel>Finalizar</ng-template>
              <div class="step-content">
                {{model | json}}
              </div>
              <div class="step-actions">
                <button matStepperPrevious class="btn btn-info mr-1">Anterior</button> 
                <button class="btn btn-info" (click)="finishSetup()">Terminar</button>
              </div>
            </mat-step>
          </mat-horizontal-stepper>
        </form>
      </div>
    </div>
  </div>
</div>